import { render } from "./CreditorsScreen.vue?vue&type=template&id=07f75d4e&scoped=true"
import script from "./CreditorsScreen.vue?vue&type=script&lang=js"
export * from "./CreditorsScreen.vue?vue&type=script&lang=js"

import "./CreditorsScreen.vue?vue&type=style&index=0&id=07f75d4e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\HanYaqoob\\Desktop\\REPOS\\DebtCrmPortalUI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f75d4e"]])

export default __exports__